import { useContext } from "react";
import { CurrentPageContext } from "../context/CurrentPage";

const useCurrentPage = () => useContext(CurrentPageContext);
export default useCurrentPage;